import React from 'react';
import {uploadProfileImage} from '../../../actions/profile';
import {REQUESTING} from '../../../constants'
import { 
	func,
	string,
	object,
} from 'prop-types';


export default class Container extends React.Component {
	static propTypes = {
		onSubmit : func.isRequired,
		comment : string,
		profileReducer : object.isRequired,
		render:func
	}
    
	constructor(props){
		super(props);
		const {profileReducer} = props;
		const {comment,userName,twitterId, imageUrl} = profileReducer;
		this.state = {
			image : null,
			comment,
			userName,
			twitterId,
			imageUrl,
			uploadProgress : 0,
			uploadState : REQUESTING.NONE,
			uploadError : null,
		};
	}
    
	render(){
		const {render,onSubmit,profileReducer,...other1} = this.props;
		const {comment,userName,twitterId,imageUrl,...other2} = profileReducer;
		return render({
			comment : this.state.comment,
			userName : this.state.userName,
			twitterId : this.state.twitterId,
			imageUrl : this.state.imageUrl,
			uploadState : this.state.uploadState,
			uploadError : this.state.uploadError,
			uploadProgress : this.state.uploadProgress,
			onChangeImage : (e)=>{
				if(e.target.files[0]){
					this.setState({
						image : e.target.files[0]
					});
				}
			},
			onChangeUserName : (e)=>{
				this.setState({
					userName : e.target.value
				});
			},
			onChangeTwitterId : (e)=>{
				this.setState({
					twitterId : e.target.value
				});
			},
			onChangeComment : (e) =>{
				this.setState({comment : e.target.value});
			},
			onSubmitImage : (id)=>()=>{
				this.state.image && 
				uploadProfileImage && uploadProfileImage(this.state.image, id, 
					(imageUrl)=>{
						// on success
						this.setState({
							uploadState : REQUESTING.LOADED,
							imageUrl
						});
					},
					(progress)=>{
						// on request
						this.setState({
							uploadState : REQUESTING.FETCHING,
							uploadProgress : progress * 100
						});
					},
					(error,type)=>{
						// on error
						this.setState({
							uploadState : REQUESTING.FAIL,
							uploadError : error
						});
					}
				);
			},
			onSubmit : (id)=>()=>{
				onSubmit && onSubmit({
					comment : this.state.comment,
					userName : this.state.userName,
					twitterId : this.state.twitterId,
					imageUrl : this.state.imageUrl
				}, id);
			}
		},{
			...other1,
			...other2
		});
	}
}